import apiClient from "./client";
import type { CompleteVia, OnboardingPatch, OnboardingSnapshot, OnboardingType } from "@/lib/onboarding/types";

/**
 * JUB-154: event creation wizard API (EventOnboardingController).
 * Errors keep the axios shape; callers read error.response.data.error.
 */
export async function startOnboarding(type: OnboardingType, key: string, language: "ro" | "en"): Promise<OnboardingSnapshot> {
  const { data } = await apiClient.post<OnboardingSnapshot>("/events/onboarding", { type, key, language });
  return data;
}

export async function getOnboarding(uuid: string): Promise<OnboardingSnapshot> {
  const { data } = await apiClient.get<OnboardingSnapshot>(`/events/${uuid}/onboarding`);
  return data;
}

export async function patchOnboarding(uuid: string, body: OnboardingPatch): Promise<OnboardingSnapshot> {
  const { data } = await apiClient.patch<OnboardingSnapshot>(`/events/${uuid}/onboarding`, body);
  return data;
}

export async function completeOnboarding(uuid: string, via: CompleteVia): Promise<OnboardingSnapshot> {
  const { data } = await apiClient.post<OnboardingSnapshot>(`/events/${uuid}/onboarding/complete`, { via });
  return data;
}

/** API error code + per-field reasons from an axios error, if any. */
export function onboardingErrorOf(error: unknown): { code: string | null; errors: Record<string, string[]> } {
  const payload = (error as { response?: { data?: { error?: { code?: string; errors?: Record<string, string[]> } } } })
    ?.response?.data?.error;
  return { code: payload?.code ?? null, errors: payload?.errors ?? {} };
}
